interface ChipInsideCircleArrowSVGProps {
  color: string;
  style: React.CSSProperties;
}

const ChipInsideCircleArrowSVG = ({
  color,
  style,
}: ChipInsideCircleArrowSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
  >
    <g clipPath="url(#clip0_875_25928)">
      <path
        d="M16.3699 32.9101H4.01986V45.2601L7.43986 41.8401C11.8699 46.4301 18.0799 49.2901 24.9499 49.2901C38.3699 49.2901 49.2899 38.3701 49.2899 24.9501C49.2899 11.5301 38.3699 0.610107 24.9499 0.610107C11.5299 0.610107 0.609863 11.5301 0.609863 24.9501H8.01986C8.01986 15.6001 15.5999 8.02011 24.9499 8.02011C34.2999 8.02011 41.8799 15.6001 41.8799 24.9501C41.8799 34.3001 34.2999 41.8801 24.9499 41.8801C20.1199 41.8801 15.7599 39.8601 12.6799 36.6101L13.1799 36.1101L12.9699 36.3201L16.3799 32.9101H16.3699Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.5 21.71H30.86"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.5 24.6399H30.86"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.5 27.5701H30.86"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.6001 24.6399H19.9501"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.6001 27.5701H19.9501"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.6602 29.4099V30.7699"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.73 29.4099V30.7699"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.8003 29.4099V30.7699"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.6602 18.51V19.86"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.73 18.51V19.86"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.09 21.71C24.09 23.01 23.04 24.07 21.73 24.07V27.57H27.59V21.71H24.09Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.6697 26.3648C34.452 21.5457 31.1795 17.0049 26.3603 16.2226C21.5412 15.4404 17.0004 18.7129 16.2182 23.532C15.4359 28.3511 18.7084 32.892 23.5275 33.6742C28.3467 34.4565 32.8875 31.1839 33.6697 26.3648Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_875_25928">
        <rect width="49.88" height="49.88" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default ChipInsideCircleArrowSVG;
